import Service 							from "./../../Libs/Service";

import { Server } 						from "./Server";

let User = new Service({

	Name: "User",

	Libraries: [],

	Events: {

	},

	Actions: {

		"InvitationDetails": function(invitationDetails) {

			this.invitationDetails = invitationDetails;

			Broadcast.call("Invitation Details Changed", [invitationDetails]);

		},

		//Получение текущего пользователя
		"User": function(user) {

			let currentUser = this.currentUser;

			this.currentUser = user;

			//Помечаем что текущий пользователь загружен (даже если user === null, это означает что пользователь не авторизован и об этом теперь будет известно на клиенте)
			this.loaded = true;

			if (user) this.setUser(user);
			else Broadcast.call("Current User Changed");

			if (!currentUser) Broadcast.call("Current User Loaded");

		},

		//Получение данных других пользователей
		"Users": function(users) {

			this.setUsers(users);

		},

		"FullUsersOnlineStatus": function(usersOnlineStatus) {

			this.usersOnlineStatus.Users = _.cloneDeep(usersOnlineStatus.Users || {});
			this.usersOnlineStatus.Unauthorized = usersOnlineStatus.Unauthorized || {};

			_.each(this.usersOnlineStatus.Users, userData => {

				this.transformUserOnlineStatusData(userData);

			});

			Broadcast.call("Users Online Status Changed");

		},

		"UserOnlineStatus": function(data) {

			let oldUserOnlineStatus = this.usersOnlineStatus.Users[data.userId];
			let newUserOnlineStatus = data.userOnlineStatus;

			if (newUserOnlineStatus) {

				this.usersOnlineStatus.Users[data.userId] = newUserOnlineStatus;

				this.transformUserOnlineStatusData(newUserOnlineStatus);

				if (oldUserOnlineStatus) Broadcast.call("User Online Status Changed");
				else Broadcast.call("User Online Status Added");

			} else if (oldUserOnlineStatus) {

				delete this.usersOnlineStatus.Users[data.userId];

				Broadcast.call("User Online Status Removed");

			}

		},

		"UserOnlineStatusAction": function(data) {

			let userOnlineStatus = this.usersOnlineStatus.Users[data.userId];

			if (userOnlineStatus) {

				userOnlineStatus.actions.push(data.action);

				this.transformUserOnlineStatusData(userOnlineStatus);

				Broadcast.call("User Online Status Changed");

			}

		}

	},

	init() {

		//Текущий пользователь
		this.User = null;

		//Данные всех пользователей переданных с сервера (хэш по id пользователя)
		this.Users = {};

		this.usersOnlineStatus = {
			Users: {}
		};

		this.COUNTRIES = {
			"au": "Australia",
			"at": "Austria",
			"az": "Azerbaijan",
			"ax": "Aland",
			"al": "Albania",
			"dz": "Algeria",
			"um": "Minor",
			"vi": "U.S.",
			"as": "American",
			"ai": "Anguilla",
			"ao": "Angola",
			"ad": "Andorra",
			"aq": "Antarctica",
			"ag": "Antigua",
			"ar": "Argentina",
			"am": "Armenia",
			"aw": "Aruba",
			"af": "Afghanistan",
			"bs": "Bahamas",
			"bd": "Bangladesh",
			"bb": "Barbados",
			"bh": "Bahrain",
			"bz": "Belize",
			"by": "Belarus",
			"be": "Belgium",
			"bj": "Benin",
			"bm": "Bermuda",
			"bg": "Bulgaria",
			"bo": "Bolivia",
			"ba": "Bosnia",
			"bw": "Botswana",
			"br": "Brazil",
			"io": "British",
			"vg": "British",
			"bn": "Brunei",
			"bf": "Burkina",
			"bi": "Burundi",
			"bt": "Bhutan",
			"vu": "Vanuatu",
			"va": "Vatican",
			"gb": "United",
			"hu": "Hungary",
			"ve": "Venezuela",
			"tl": "East",
			"vn": "Vietnam",
			"ga": "Gabon",
			"ht": "Haiti",
			"gy": "Guyana",
			"gm": "Gambia",
			"gh": "Ghana",
			"gp": "Guadeloupe",
			"gt": "Guatemala",
			"gn": "Guinea",
			"gw": "Guinea-Bissau",
			"de": "Germany",
			"gi": "Gibraltar",
			"hn": "Honduras",
			"hk": "Hong",
			"gd": "Grenada",
			"gl": "Greenland",
			"gr": "Greece",
			"ge": "Georgia",
			"gu": "Guam",
			"dk": "Denmark",
			"cd": "DR",
			"dj": "Djibouti",
			"dm": "Dominica",
			"do": "Dominican",
			"eu": "European",
			"eg": "Egypt",
			"zm": "Zambia",
			"eh": "Western",
			"zw": "Zimbabwe",
			"il": "Israel",
			"in": "India",
			"id": "Indonesia",
			"jo": "Jordan",
			"iq": "Iraq",
			"ir": "Iran",
			"ie": "Ireland",
			"is": "Iceland",
			"es": "Spain",
			"it": "Italy",
			"ye": "Yemen",
			"kp": "North",
			"cv": "Cape",
			"kz": "Kazakhstan",
			"ky": "Cayman",
			"kh": "Cambodia",
			"cm": "Cameroon",
			"ca": "Canada",
			"qa": "Qatar",
			"ke": "Kenya",
			"cy": "Cyprus",
			"kg": "Kyrgyzstan",
			"ki": "Kiribati",
			"cn": "China",
			"cc": "Cocos",
			"co": "Colombia",
			"km": "Comoros",
			"cr": "Costa",
			"ci": "Ivory",
			"cu": "Cuba",
			"kw": "Kuwait",
			"la": "Laos",
			"lv": "Latvia",
			"ls": "Lesotho",
			"lr": "Liberia",
			"lb": "Lebanon",
			"ly": "Libya",
			"lt": "Lithuania",
			"li": "Liechtenstein",
			"lu": "Luxembourg",
			"mu": "Mauritius",
			"mr": "Mauritania",
			"mg": "Madagascar",
			"yt": "Mayotte",
			"mo": "Macau",
			"mk": "Republic",
			"mw": "Malawi",
			"my": "Malaysia",
			"ml": "Mali",
			"mv": "Maldives",
			"mt": "Malta",
			"ma": "Morocco",
			"mq": "Martinique",
			"mh": "Marshall",
			"mx": "Mexico",
			"mz": "Mozambique",
			"md": "Moldova",
			"mc": "Monaco",
			"mn": "Mongolia",
			"ms": "Montserrat",
			"mm": "Myanmar",
			"na": "Namibia",
			"nr": "Nauru",
			"np": "Nepal",
			"ne": "Niger",
			"ng": "Nigeria",
			"an": "Netherlands",
			"nl": "The",
			"ni": "Nicaragua",
			"nu": "Niue",
			"nc": "New",
			"nz": "New",
			"no": "Norway",
			"ae": "UAE",
			"om": "Oman",
			"cx": "Christmas",
			"ck": "Cook",
			"hm": "Heard",
			"pk": "Pakistan",
			"pw": "Palau",
			"ps": "Palestine",
			"pa": "Panama",
			"pg": "Papua",
			"py": "Paraguay",
			"pe": "Peru",
			"pn": "Pitcairn",
			"pl": "Poland",
			"pt": "Portugal",
			"pr": "Puerto",
			"cg": "Republic",
			"re": "Reunion",
			"ru": "Russia",
			"rw": "Rwanda",
			"ro": "Romania",
			"us": "USA",
			"sv": "El",
			"ws": "Samoa",
			"sm": "San",
			"st": "Sao",
			"sa": "Saudi",
			"sz": "Swaziland",
			"sj": "Svalbard",
			"mp": "Northern",
			"sc": "Seychelles",
			"sn": "Senegal",
			"vc": "St.",
			"kn": "Saint",
			"lc": "Saint",
			"pm": "Saint",
			"rs": "Serbia",
			"cs": "Serbia",
			"sg": "Singapore",
			"sy": "Syria",
			"sk": "Slovakia",
			"si": "Slovenia",
			"sb": "Solomon",
			"so": "Somalia",
			"sd": "Sudan",
			"sr": "Suriname",
			"sl": "Sierra",
			"su": "USSR",
			"tj": "Tajikistan",
			"th": "Thailand",
			"tw": "Republic",
			"tz": "Tanzania",
			"tg": "Togo",
			"tk": "Tokelau",
			"to": "Tonga",
			"tt": "Trinidad",
			"tv": "Tuvalu",
			"tn": "Tunisia",
			"tm": "Turkmenistan",
			"tr": "Turkey",
			"ug": "Uganda",
			"uz": "Uzbekistan",
			"ua": "Ukraine",
			"uy": "Uruguay",
			"fo": "Faroe",
			"fm": "Micronesia",
			"fj": "Fiji",
			"ph": "Philippines",
			"fi": "Finland",
			"fk": "Falkland",
			"fr": "France",
			"gf": "French",
			"pf": "French",
			"tf": "French",
			"hr": "Croatia",
			"cf": "CAR",
			"td": "Chad",
			"me": "Montenegro",
			"cz": "Czech",
			"cl": "Chile",
			"ch": "Switzerland",
			"se": "Sweden",
			"lk": "Sri",
			"ec": "Ecuador",
			"gq": "Equatorial",
			"er": "Eritrea",
			"ee": "Estonia",
			"et": "Ethiopia",
			"za": "South",
			"kr": "Republic",
			"gs": "South",
			"jm": "Jamaica",
			"jp": "Japan",
			"bv": "Bouvet",
			"nf": "Norfolk",
			"sh": "Saint",
			"tc": "Turks",
			"wf": "Wallis"
		};

	},

	setUser(newUser) {

		let oldUser = this.Users[newUser.id];

		this.Users[newUser.id] = newUser;

		if (this.currentUser?.id === newUser.id) this.currentUser = newUser;

		Broadcast.call("User Changed", [newUser.id]);

		if (this.currentUser?.id === newUser.id) Broadcast.call("Current User Changed");

		//Определяем что конкретно изменилось, чтобы точечно обновить только нужные части UI дашборда
		if (oldUser && newUser) {

			let oldUserFeatures = oldUser['options']?.['features'] || {};
			let newUserFeatures = newUser['options']?.['features'] || {};

			let featureNames = _.uniq(_.keys(oldUserFeatures).concat(_.keys(newUserFeatures)));

			_.each(featureNames, featureName => {

				if (oldUserFeatures[featureName] !== newUserFeatures[featureName]) {

					if (this.currentUser?.id === newUser.id) Broadcast.call("Current User Feature Changed", [featureName, newUserFeatures[featureName]]);
					else Broadcast.call("User Feature Changed", [featureName, newUserFeatures[featureName]]);

				}

			});

		}

	},

	setUsers(users) {

		_.each(users, user => {

			this.setUser(user);

		});

	},

	transformUserOnlineStatusData(userData) {

		let userActionsGrouped = {};

		_.each(userData.actions, action => {

			this.transformUserOnlineStatusAction(action);

			this.pushUserOnlineStatusActionToGroup(userActionsGrouped, action);

		});

		userData.actionsGrouped = _.reverse(_.orderBy(_.values(userActionsGrouped), 'date'));

	},

	transformUserOnlineStatusAction(action) {

		if (typeof action[0] === 'string') action[0] = new Date(action[0]);

	},

	pushUserOnlineStatusActionToGroup(actionsGrouped, action) {

		let date = action[0].toLocaleDateString();

		if (!actionsGrouped[date]) actionsGrouped[date] = {date: date, title: date, actions: []};

		if (date === (new Date()).toLocaleDateString()) actionsGrouped[date].title = 'Today';
		else if (date === (new Date(Date.now() - 24 * 3600 * 1000)).toLocaleDateString()) actionsGrouped[date].title = 'Yesterday';

		actionsGrouped[date].actions.push(action);

	},

	getLastActiveVersionData(userData) {

		let connections = _.sortBy(userData.connections, "versionTime");
		return connections[connections.length-1];

	},

	logout() {

		Server.sendToSocket({
			Logout: true
		});

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.User) User = window.User;
else window.User = User;

export { User }

